export const CHANNELS = Object.freeze({
    ALL: 'ALL',
    RETAIL: 'RETAIL',
    FBA: 'FBA',
    MFN: 'MFN',
    WD: 'WAREHOUSE_DEALS'
});


// WEBPACK FOOTER //
// ./src/constants/channels.jsx